<div class="wrap">
    <div class="header">
      <div class="title">
        <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin/structure']" routerLinkActive="router-link-active"
        appChangeColorTheme attribute="color"></fa-icon>
  
        <form [formGroup]="updateStructureForm" (ngSubmit)="onSubmit()" >
          <mat-form-field appearance="outline">
            <mat-label>Nom de la structure</mat-label>
            <input matInput type="text" formControlName="structureName">
          </mat-form-field>
  
          <div class="btn_action">
            <button type="button" class="back" (click)="goBack()" >Annuler</button>
            <button type="submit" class="confirm" [disabled]="updateStructureForm.invalid"
              [style.opacity]="updateStructureForm.invalid? .5 : 1"  appChangeColorTheme attribute="bgc">Sauvegarder</button>
          </div>
        </form>
      </div>
  
      <div class="add_search_structure"  >
        
        <div class="search_bar">
          <form [formGroup]="searchForm">
            <input type="text" placeholder="Chercher un club ..." (input)="applyFilter($event.target.value)"
              formControlName="keyword">
          </form>
  
          <fa-icon [icon]="getFaIcon('faTimes')" (click)="resetSearch()" class="faTimes" *ngIf="valueInput"></fa-icon>
          <fa-icon [icon]="getFaIcon('faSearch')" *ngIf="!valueInput"></fa-icon>
  
        </div>
      </div>
    </div>
  
    <div class="content" >
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows class="mat-elevation-z8">
  
        <ng-container matColumnDef="clubCode">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="clubCode" class="cell_code_club"> Code
          </th>
          <td mat-cell *matCellDef="let element" class="cell_code_club"> {{element?.clubCode}} </td>
        </ng-container>
  
        <ng-container matColumnDef="clubName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="clubName" class="cell_club">Nom du club </th>
          <td mat-cell *matCellDef="let element" class="cell_club"> {{element?.clubName}} </td>
        </ng-container>
  
        <ng-container matColumnDef="isActive" >
          <th mat-header-cell mat-sort-header="isActive" *matHeaderCellDef class="cell_action"
            [style.text-align]="'right !important'"> Act./Dés. </th>
          <td mat-cell *matCellDef="let element" class="cell_action">
            <mat-slide-toggle size="large" (toggleChange)="addOrDeleteCLub(element)" [color]="color"
              [checked]="clubISelected(element)"></mat-slide-toggle>
          </td>
        </ng-container>
  
  
        <tr mat-header-row *matHeaderRowDef=" displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
      </table>
      <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = $event" [color]="color">
      </mat-paginator>
    </div>
  
  
  
  </div>
  